export default __webpack_public_path__ + "static/media/youtube.37a64ad8.svg";